import { render, staticRenderFns } from "./RemoveFromCollectionBtn.vue?vue&type=template&id=56357688&"
import script from "./RemoveFromCollectionBtn.vue?vue&type=script&lang=js&"
export * from "./RemoveFromCollectionBtn.vue?vue&type=script&lang=js&"
import style0 from "./RemoveFromCollectionBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports